// app-it.js — Version italiana

// Imports dei moduli
// UNICA DIFFERENZA rispetto a app.js: si importa ui-manager-it.js
import { setupRecorder } from './modules/recorder.js';
import { visualize } from './modules/visualizer.js';
import { 
  createIcon, 
  replaceButtonTextsWithIcons, 
  initButtonObserver,
  createProgressBar,
  setupProMode,
  createCombinedClipsContainer,
  createDownloadAllButton
} from './modules/ui-manager-it.js';   // ← version italienne
import { 
  createAudioClip, 
  downloadAllClips 
} from './modules/clip-manager-it.js';          // ← version italienne
import { 
  combineAudioClips, 
  combineAndNormalizeAudioClips 
} from './modules/combine-normalize.js';
import { 
  processImportedAudio, 
  setupImportOptions, 
  createLibraryModal 
} from './modules/import-manager-it.js';         // ← version italienne
import { 
  setupKeyboardShortcuts, 
  setupBeforeUnloadAlert 
} from './modules/keyboard-shortcuts.js';
import {
  createProjectManagerModal,
} from './modules/project-manager-ui-it.js';      // ← version italienne

// Testi italiani
const i18n = {
  noMic: 'getUserMedia non è supportato dal vostro browser.',
  clipName: 'Nome del clip?',
  clipDefaultName: 'senzaNome',
  atLeastTwo: 'Dovete avere almeno due clip audio per combinarli.',
  combinedName: 'Inserite un nome per il clip combinato',
  combinedDefault: 'clipCombinato',
  normalizedName: 'Inserite un nome per il clip normalizzato',
  normalizedDefault: 'clipNormalizzato',
  projectLoaded: (name, count) => `Progetto "${name}" caricato con successo!\n${count} clip ripristinato/i.`,
  importError: 'L\'audio non ha potuto essere importato. Riprovare.',
  soundError: 'Il suono non ha potuto essere caricato. Riprovare.',
};

document.addEventListener('DOMContentLoaded', () => {

  // ====================
  // Configurazione e inizializzazione
  // ====================

  const recordButton = document.querySelector('.record');
  const stopButton = document.querySelector('.stop');
  const soundClips = document.querySelector('.sound-clips');
  const canvas = document.querySelector('.visualizer');
  const combineButton = document.querySelector('.combine');
  const proModeToggle = document.querySelector('.pro-mode-toggle');
  const importButton = document.querySelector('.import-button');
  const fileInput = document.querySelector('.file-input');

  // Pulsante normalizza
  const normalizeButton = document.createElement('button');
  normalizeButton.textContent = 'Combina e Normalizza';
  normalizeButton.setAttribute('data-icon', 'normalize');
  normalizeButton.title = 'Combina e Normalizza';
  normalizeButton.className = 'normalize';
  normalizeButton.classList.add('hidden');
  normalizeButton.style.display = 'none';

  // Barra di avanzamento
  const { progressContainer, updateProgressBar } = createProgressBar();
  soundClips.parentNode.insertBefore(progressContainer, soundClips);

  // Timer display
  const timerDisplay = document.createElement('div');
  timerDisplay.className = 'timer-display';
  timerDisplay.style.display = 'none';
  soundClips.parentNode.insertBefore(timerDisplay, soundClips);

  if (typeof lamejs === 'undefined') {
    throw new Error('La libreria lamejs non è caricata');
  }

  // ====================
  // Configurazione dell'interfaccia
  // ====================

  const combineButtonContainer = document.createElement('div');
  combineButtonContainer.style.textAlign = 'center';
  combineButtonContainer.appendChild(combineButton);
  combineButtonContainer.appendChild(normalizeButton);

  const combinedClipsContainer = createCombinedClipsContainer();

  const downloadAllContainer = createDownloadAllButton(async () => {
    const downloadButton = downloadAllContainer.querySelector('.download-all');
    downloadButton.disabled = true;
    try {
      await downloadAllClips();
    } finally {
      downloadButton.disabled = false;
    }
  });

  // Gestione progetti
  const projectManager = createProjectManagerModal((projectData) => {
    document.querySelectorAll('.sound-clips .clip').forEach(clip => clip.remove());
    projectData.clipsWithBlobs.forEach(clip => {
      createAudioClip(
        clip.blob,
        clip.name,
        soundClips,
        updateProgressBar,
        () => isProMode
      );
    });
    alert(i18n.projectLoaded(projectData.name, projectData.clips.length));
  });

  const projectManagerButton = document.querySelector('.project-manager-toggle');
  if (projectManagerButton) {
    projectManagerButton.addEventListener('click', () => {
      projectManager.show();
    });
  }

  soundClips.parentNode.insertBefore(combineButtonContainer, soundClips.nextSibling);
  soundClips.parentNode.insertBefore(combinedClipsContainer, combineButtonContainer.nextSibling);
  soundClips.parentNode.insertBefore(downloadAllContainer, soundClips.nextSibling);

  // ====================
  // Modalità Pro
  // ====================

  const { importOptions, importFromComputerButton, importFromLibraryButton } = setupImportOptions({
    importButton,
    fileInput,
    onComputerImport: () => {},
    onLibraryImport: () => {},
    getIsProMode: () => isProMode
  });

  const { isProMode: getIsProMode } = setupProMode({
    proModeToggle,
    importButton,
    normalizeButton,
    importFromComputerButton,
    importFromLibraryButton,
    importOptions
  });

  let isProMode = false;
  proModeToggle.addEventListener('click', () => {
    isProMode = getIsProMode();
  });

  if (window.location.protocol === 'file:') {
    if (importFromLibraryButton) {
      importFromLibraryButton.style.display = 'none';
    }
  }

  // ====================
  // Import
  // ====================

  fileInput.addEventListener('change', async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        progressContainer.style.display = 'block';
        updateProgressBar(0);

        let progress = 0;
        const processInterval = setInterval(() => {
          if (progress < 100) { progress += 20; updateProgressBar(progress); }
        }, 500);

        const audioBlob = await processImportedAudio(file);
        clearInterval(processInterval);
        updateProgressBar(100);
        createAudioClip(audioBlob, file.name, soundClips, updateProgressBar, () => isProMode);
      } catch (error) {
        console.error('Errore durante l\'importazione', error);
        alert(i18n.importError);
        updateProgressBar(0);
      } finally {
        progressContainer.style.display = 'none';
      }
    }
  });

  const { libraryModal, showLibrary } = createLibraryModal(async (src, name) => {
    try {
      progressContainer.style.display = 'block';
      updateProgressBar(0);

      let progress = 0;
      const processInterval = setInterval(() => {
        if (progress < 100) { progress += 20; updateProgressBar(progress); }
      }, 500);

      const response = await fetch(src);
      const audioBlob = await response.blob();
      clearInterval(processInterval);
      updateProgressBar(100);
      createAudioClip(audioBlob, name, soundClips, updateProgressBar, () => isProMode);
      libraryModal.style.display = 'none';
    } catch (error) {
      console.error('Errore durante la selezione del suono', error);
      alert(i18n.soundError);
      updateProgressBar(0);
    } finally {
      progressContainer.style.display = 'none';
    }
  });

  importFromLibraryButton.removeEventListener('click', () => {});
  importFromLibraryButton.addEventListener('click', () => {
    if (!isProMode) return;
    showLibrary();
    importOptions.style.display = 'none';
  });

  // ====================
  // Registrazione
  // ====================

  setupRecorder({
    recordButton,
    stopButton,
    soundClips,
    timerDisplay,
    isProMode: () => isProMode,
    createAudioClip: (blob, fileName) => createAudioClip(blob, fileName, soundClips, updateProgressBar, () => isProMode),
    // Textes italiens injectés dans recorder
    promptClipName: () => prompt(i18n.clipName, i18n.clipDefaultName),
    alertNoMic: () => alert(i18n.noMic),
  });

  stopButton.disabled = true;

  // ====================
  // Combina e Normalizza
  // ====================

  combineButton.onclick = async function() {
    const audioElements = document.querySelectorAll('.sound-clips .clip audio');
    if (audioElements.length < 2) {
      alert(i18n.atLeastTwo);
      return;
    }
    const combinedClipName = prompt(i18n.combinedName, i18n.combinedDefault);
    if (!combinedClipName) return;

    combineButton.disabled = true;
    try {
      await combineAudioClips(audioElements, combinedClipName, combinedClipsContainer, combineButtonContainer);
    } finally {
      combineButton.disabled = false;
    }
  };

  normalizeButton.onclick = async function() {
    const audioElements = document.querySelectorAll('.sound-clips .clip audio');
    if (audioElements.length < 2) {
      alert(i18n.atLeastTwo);
      return;
    }
    const combinedClipName = prompt(i18n.normalizedName, i18n.normalizedDefault);
    if (!combinedClipName) return;

    normalizeButton.disabled = true;
    try {
      await combineAndNormalizeAudioClips(audioElements, combinedClipName, combinedClipsContainer, combineButtonContainer);
    } finally {
      normalizeButton.disabled = false;
    }
  };

  // ====================
  // Raccourcis clavier et événements
  // ====================

  setupKeyboardShortcuts({ recordButton, stopButton });
  setupBeforeUnloadAlert();

  // ====================
  // Position controls
  // ====================

  const controls = document.querySelector('.controls-container');
  if (controls) {
    const BASE_TOP = 20;
    const updateControlsPosition = () => {
      const offsetTop = window.visualViewport
        ? window.visualViewport.offsetTop
        : window.pageYOffset || 0;
      controls.style.top = `${BASE_TOP + offsetTop}px`;
    };
    updateControlsPosition();
    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', updateControlsPosition);
      window.visualViewport.addEventListener('resize', updateControlsPosition);
    } else {
      window.addEventListener('scroll', updateControlsPosition);
      window.addEventListener('resize', updateControlsPosition);
    }
  }

  // ====================
  // Icônes
  // ====================

  replaceButtonTextsWithIcons();
  initButtonObserver();

});